import styled from "@emotion/styled";
import { Score24Icon } from "@kaltura/ds-react-icons";

export const ScoreIcon = styled(Score24Icon)(({ theme }) => ({
    color: theme.kaltura.palette.brand.yellow.main,
}));
